import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from '../../../models/allpayments'; // Importing allpayments model for data handling
import { devConfig, countries, gamesCasino } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing a view for table messages.
 * @extends JetView
 */
export default class tableMessagesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            rows: [
                {
                    id: 'preloader', // Identifier for the preloader element
                    cols: [
                        {
                            type: 'wide', // Type of the view
                            view: 'datatable', // Data table view
                            id: 'datatable', // Identifier for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Identifier for the rating column
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    template: function (obj) {
                                        // Template function for rendering the column
                                        // Check if the user has permission to edit messages
                                        if (devConfig.getPermAction('messageListEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                }, // Column for Id with sorting
                                {
                                    id: 'ClientIdFrom',
                                    header: _('Emisor'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for sender Id
                                {
                                    id: 'ClientIdTo',
                                    header: _('Receptor'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for receiver Id
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha Expiración'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for expiration date
                                {
                                    id: 'Title',
                                    header: _('Asunto'),
                                    width: 200,
                                    sort: 'int',
                                }, // Column for message title
                                {
                                    id: 'Message',
                                    header: _('Mensaje'),
                                    width: 300,
                                    sort: 'int',
                                }, // Column for message content
                                {
                                    id: 'State', // Identifier for the state column
                                    header: _('Leido'), // Header for the column
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Option for 'Yes'
                                        { id: '0', value: _('No') }, // Option for 'No'
                                    ],
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('editwinMessages').show(); // Show edit window
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Identifier for the pager
                            url: devConfig.geturlApi() + 'Client/GetClientMessages', // API endpoint for fetching data
                        },
                        {
                            type: 'wide', // Type of the view
                            view: 'datatable', // Data table view
                            id: 'datatable1', // Identifier for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Identifier for the rating column
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    template: function (obj) {
                                        // Template function for rendering the column
                                        // Check if the user has permission to edit messages
                                        if (devConfig.getPermAction('messageListEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                }, // Column for Id with sorting
                                {
                                    id: 'Image',
                                    header: _('URL Imagen'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for image URL
                                {
                                    id: 'Redirection',
                                    header: _('URL Redirección'),
                                    width: 150,
                                    sort: 'int',
                                }, // Column for redirection URL
                                {
                                    id: 'Content',
                                    header: _('Contenido'),
                                    width: 250,
                                    sort: 'int',
                                }, // Column for content
                                {
                                    id: 'ButtonText',
                                    header: _('Texto del botón'),
                                    width: 250,
                                    sort: 'int',
                                }, // Column for button text
                                {
                                    id: 'ClientId',
                                    header: _('Usuarios Id'),
                                    width: 250,
                                    sort: 'int',
                                }, // Column for user Id
                                {
                                    id: 'CountrySelect', // Identifier for the country selection column
                                    header: _('País'), // Header for the column
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if no permission
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateSend',
                                    header: _('Fecha envío'),
                                    width: 200,
                                    sort: 'int',
                                }, // Column for send date
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha expiración'),
                                    width: 300,
                                    sort: 'int',
                                }, // Column for expiration date
                                {
                                    id: 'State', // Identifier for the state column
                                    header: _('Estado'), // Header for the column
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') }, // Option for 'Active'
                                        { id: 'I', value: _('Inactivo') }, // Option for 'Inactive'
                                    ],
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditInvasiveBanner').show(); // Show edit window
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA1', // Identifier for the pager
                            url: devConfig.geturlApi() + 'Client/GetClientSendInvasiveBanner', // API endpoint for fetching data
                        },
                        {
                            type: 'wide', // Type of the view
                            view: 'datatable', // Data table view
                            id: 'datatable2', // Identifier for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Identifier for the rating column
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    template: function (obj) {
                                        // Template function for rendering the column
                                        // Check if the user has permission to edit messages
                                        if (devConfig.getPermAction('messageListEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                }, // Column for Id with sorting
                                {
                                    id: 'Title',
                                    header: _('Título'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for title
                                {
                                    id: 'Content',
                                    header: _('Contenido'),
                                    width: 300,
                                    sort: 'int',
                                }, // Column for content
                                {
                                    id: 'IsGame', // Identifier for the game column
                                    header: _('¿Es un juego?'), // Header for the column
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Option for 'Yes'
                                        { id: '0', value: _('No') }, // Option for 'No'
                                    ],
                                    width: 70, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Redirection',
                                    header: _('URL Redirección'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for redirection URL
                                {
                                    id: 'Frame',
                                    header: _('URL Frame'),
                                    width: 200,
                                    sort: 'int',
                                }, // Column for frame URL
                                {
                                    id: 'Product',
                                    header: _('Juego'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for game
                                {
                                    id: 'ClientId',
                                    header: _('Usuarios Id'),
                                    width: 250,
                                    sort: 'int',
                                }, // Column for user Id
                                {
                                    id: 'CountrySelect', // Identifier for the country selection column
                                    header: _('País'), // Header for the column
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if no permission
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 300, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateSend',
                                    header: _('Fecha envío'),
                                    width: 200,
                                    sort: 'int',
                                }, // Column for send date
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha expiración'),
                                    width: 300,
                                    sort: 'int',
                                }, // Column for expiration date
                                {
                                    id: 'State', // Identifier for the state column
                                    header: _('Estado'), // Header for the column
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') }, // Option for 'Active'
                                        { id: 'I', value: _('Inactivo') }, // Option for 'Inactive'
                                    ],
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditPopup').show(); // Show edit window
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA2', // Identifier for the pager
                            url: devConfig.geturlApi() + 'Client/GetClientSendPopup', // API endpoint for fetching data
                        },
                        {
                            type: 'wide', // Type of the view
                            view: 'datatable', // Data table view
                            id: 'datatable3', // Identifier for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Identifier for the rating column
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    template: function (obj) {
                                        // Template function for rendering the column
                                        // Check if the user has permission to edit messages
                                        if (devConfig.getPermAction('messageListEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                }, // Column for Id with sorting
                                {
                                    id: 'Content',
                                    header: _('Contenido'),
                                    width: 500,
                                    sort: 'int',
                                }, // Column for content
                                {
                                    id: 'ClientId',
                                    header: _('Usuarios Id'),
                                    width: 100,
                                    sort: 'int',
                                }, // Column for user Id
                                {
                                    id: 'Redirection',
                                    header: _('URL Redirección'),
                                    width: 350,
                                    sort: 'int',
                                }, // Column for redirection URL
                                {
                                    id: 'CountrySelect', // Identifier for the country selection column
                                    header: _('País'), // Header for the column
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if no permission
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateSend',
                                    header: _('Fecha envío'),
                                    width: 150,
                                    sort: 'int',
                                }, // Column for send date
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha expiración'),
                                    width: 150,
                                    sort: 'int',
                                }, // Column for expiration date
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditFringe').show(); // Show edit window
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA3', // Identifier for the pager
                            url: devConfig.geturlApi() + 'Client/GetClientSendFringe', // API endpoint for fetching data
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and assign the translation function to _
        const _ = this.app.getService('locale')._;

        // Initialize the main data table
        grid = $$('datatable');

        // Hide additional data tables and toolbars
        $$('datatable1').hide();
        $$('datatable2').hide();
        $$('datatable3').hide();
        $$('toolbar1').hide();
        $$('toolbar2').hide();
        $$('toolbar3').hide();

        // Retrieve URLs for data tables
        var url = grid.data.url; // URL for the main data table
        var url1 = $$('datatable1').data.url; // URL for the first additional data table
        var url2 = $$('datatable2').data.url; // URL for the second additional data table
        var url3 = $$('datatable3').data.url; // URL for the third additional data table

        // Initialize an empty filter variable
        var filter = '';

        // Create a modal window for editing messages
        var popup = webix.ui({
            view: 'window',
            id: 'editwinMessages', // Unique identifier for the window
            fullscreen: true, // Set the window to fullscreen mode
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Mensaje') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Hide the window when the close icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // Unique identifier for the form
                elements: [
                    {
                        rows: [
                            {
                                view: 'text',
                                label: _('ID Usuario'),
                                name: 'ClientIdTo',
                            }, // Input for user ID
                            { view: 'text', label: _('Asunto'), name: 'Title' }, // Input for subject
                            {
                                view: 'ckeditor5', // Rich text editor for message input
                                label: _('Mensaje'),
                                name: 'Message',
                                onReady(eventData) {
                                    // Set up file upload adapter when the editor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        return new UploadAdapter(loader);
                                    };
                                },
                                ready: function (eventData) {
                                    // Set up file upload adapter when the editor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        return new UploadAdapter(loader);
                                    };
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button to close the window
                                value: _('Cerrar'), // Button label
                                click: function () {
                                    // Hide the window and reset the add form values
                                    this.getTopParentView().hide();
                                    $$('addform').setValues($$('addform').getCleanValues());
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a popup window for adding messages using Webix UI
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddMessages', // Unique identifier for the window
            fullscreen: true, // Set the window to fullscreen mode
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Añadir Mensaje') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    {
                        rows: [
                            // Define rows of form elements
                            {
                                view: 'text',
                                label: _('ID Usuario'),
                                name: 'ClientId',
                            }, // Text input for user ID
                            {
                                view: 'datepicker', // Datepicker for expiration date
                                label: _('Fecha Expiración'),
                                name: 'DateExpiration',
                                timepicker: true, // Enable time selection
                            },
                            { view: 'text', label: _('Asunto'), name: 'Title' }, // Text input for subject
                            {
                                view: 'richselect', // Dropdown for country selection
                                name: 'CountrySelect',
                                id: 'CountrySelect',
                                label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                                placeholder: _('Click para seleccionar '), // Placeholder text
                                options: {
                                    body: {
                                        template: function (obj) {
                                            // Template for displaying country options
                                            return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag and name
                                        },
                                        data: countries, // Data source for country options
                                    },
                                },
                                hidden: devConfig.getCountryReport(), // Hide based on configuration
                            },
                            {
                                view: 'ckeditor5', // Rich text editor for message input
                                label: _('Mensaje'),
                                name: 'Message',
                                onReady(eventData) {
                                    // Event when the editor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Set up file upload adapter
                                        return new UploadAdapter(loader);
                                    };
                                },
                                ready: function (eventData) {
                                    // Another event when the editor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Set up file upload adapter
                                        return new UploadAdapter(loader);
                                    };
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            // Define columns for action buttons
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event to cancel
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type as form submit
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event to save
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Client/SaveClientMessage', // API endpoint for saving message
                                            JSON.stringify(values), // Send form values as JSON
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message('Cell value was changed'); // Show success message
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                                },
                                            },
                                        );
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a local date string in the format YYYY:MM:DD HH:MM:SS
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() + // Get the current year
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) + // Get the current month (0-indexed)
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) + // Get the current day
            ' ' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) + // Get the current hour
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2) + // Get the current minutes
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getSeconds()).slice(-2); // Get the current seconds

        // Create a popup window for sending an invasive banner
        var popupSendInvasiveBanner = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'SendInvasiveBanner', // Unique identifier for the window
            width: screen.width < 500 ? 350 : 650, // Set width based on screen size
            height: screen.width < 500 ? 750 : 550, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen for small screens
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    {
                        view: 'label',
                        label: _('Enviar banner invasivo'),
                        align: 'center',
                    }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close window on click
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form for user input
                    id: 'formSendInvasiveBanner', // Unique identifier for the form
                    width: screen.width < 500 ? 350 : 650, // Set form width based on screen size
                    height: screen.width < 500 ? 750 : 500, // Set form height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for image URL
                            label: _('URL Imagen'),
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Image', // Name of the input field
                            labelWidth: 150, // Width of the label
                            required: true, // Mark as required
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Redirection',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'textarea', // Textarea for content
                            label: _('Contenido'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Content',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'text', // Text input for button text
                            label: _('Texto del botón'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ButtonText',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'textarea', // Textarea for user IDs
                            label: _('Usuarios Id'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ClientId',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            placeholder: _('Click para seleccionar '),
                            labelWidth: 150,
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            required: true,
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateSend',
                            stringResult: true, // Return date as string
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s', // Date format
                            value: createdLocalDate, // Default value set to createdLocalDate
                            timepicker: true, // Enable time selection
                            required: true,
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateExpiration',
                            stringResult: true,
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s',
                            value: createdLocalDate, // Default value set to createdLocalDate
                            timepicker: true,
                            required: true,
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Click event to hide the window and reset form
                                        this.getTopParentView().hide();
                                        $$('formSendInvasiveBanner').setValues(
                                            $$('formSendInvasiveBanner').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form',
                                    value: _('Enviar'),
                                    click: function ($e) {
                                        // Click event to send form data
                                        var values = $$('formSendInvasiveBanner').getValues(); // Get form values
                                        if ($$('formSendInvasiveBanner').validate()) {
                                            // Validate form
                                            webix
                                                .ajax() // AJAX request to send data
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendInvasiveBanner', // API endpoint
                                                    '{"Image":"' +
                                                        values.Image +
                                                        '",  "Redirection":"' +
                                                        values.Redirection +
                                                        '", "Content":"' +
                                                        values.Content +
                                                        '", "ButtonText":"' +
                                                        values.ButtonText +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}', // JSON payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Success handling
                                                            data = JSON.parse(text); // Parse response
                                                            if (data.HasError) {
                                                                // Check for errors in response
                                                                webix.message({
                                                                    text: _('Error, comuniquese con soporte. '),
                                                                    type: 'error',
                                                                });
                                                            } else {
                                                                webix.message(
                                                                    _('Banner invasivo enviado satisfactoriamente'), // Success message
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendInvasiveBanner').setValues(
                                                $$('formSendInvasiveBanner').getCleanValues(), // Reset form values
                                            );
                                            this.getTopParentView().hide(); // Hide the window
                                            console.log(values); // Log the values
                                        } else {
                                            webix.message({
                                                // Show error message if validation fails
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _('Completa los campos...'),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            onChange: function () {
                                // Validate fields on change
                                this.validate();
                            },
                        },
                    },
                },
            },
        });
        // Create a Webix UI window for editing an invasive banner
        var popupEditInvasiveBanner = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditInvasiveBanner', // Unique identifier for the window
            width: screen.width < 500 ? 350 : 650, // Set width based on screen size
            height: screen.width < 500 ? 800 : 620, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen for small screens
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    {
                        view: 'label',
                        label: _('Editar banner invasivo'),
                        align: 'center',
                    }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form for editing banner details
                    id: 'formEditInvasiveBanner', // Unique identifier for the form
                    width: screen.width < 500 ? 350 : 650, // Set form width based on screen size
                    height: screen.width < 500 ? 800 : 570, // Set form height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for Id
                            label: _('Id'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Id', // Name of the input field
                            labelWidth: 150, // Width of the label
                            readonly: true, // Make the input read-only
                        },
                        {
                            view: 'text', // Text input for Image URL
                            label: _('URL Imagen'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Image', // Name of the input field
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'text', // Text input for Redirection URL
                            label: _('URL Redirección'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name of the input field
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'textarea', // Textarea for Content
                            label: _('Contenido'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'text', // Text input for Button Text
                            label: _('Texto del botón'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ButtonText', // Name of the input field
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'textarea', // Textarea for Client Ids
                            label: _('Usuarios Id'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'richselect', // Rich select for Country selection
                            name: 'CountrySelectId', // Name of the select field
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Width of the label
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Display flag icon and country name
                                    },
                                    data: countries, // Data source for country options
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name of the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            timepicker: true, // Enable time selection
                            format: '%d %M %Y %H:%i:%s', // Date format
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name of the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            timepicker: true, // Enable time selection
                            format: '%d %M %Y %H:%i:%s', // Date format
                        },
                        {
                            view: 'combo', // Combo box for State selection
                            label: _('Estado'), // Label for the combo box
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'State', // Name of the combo box
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') }, // Activated option
                                { id: 'I', value: _('Inactivado') }, // Inactivated option
                            ],
                            labelWidth: 150, // Width of the label
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Click event for cancel button
                                        this.getTopParentView().hide(); // Hide the window
                                        $$('formEditInvasiveBanner').setValues(
                                            // Reset form values
                                            $$('formEditInvasiveBanner').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label
                                    click: function ($e) {
                                        // Click event for save button
                                        var values = $$('formEditInvasiveBanner').getValues(); // Get form values
                                        webix // AJAX request to save the invasive banner
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SaveInvasiveBanner', // API endpoint
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Image":"' +
                                                    values.Image +
                                                    '",  "Redirection":"' +
                                                    values.Redirection +
                                                    '", "Content":"' +
                                                    values.Content +
                                                    '", "ButtonText":"' +
                                                    values.ButtonText +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelectId +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error callback
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success callback
                                                        data = JSON.parse(text); // Parse response
                                                        if (data.HasError) {
                                                            // Check for errors in response
                                                            webix.message({
                                                                text: _('Error, comuniquese con soporte. '), // Show error message
                                                                type: 'error',
                                                            });
                                                        } else {
                                                            webix.message(
                                                                // Show success message
                                                                _('Banner invasivo editado satisfactoriamente'),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditInvasiveBanner').setValues(
                                            // Reset form values
                                            $$('formEditInvasiveBanner').getCleanValues(),
                                        );
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditInvasiveBanner').bind($$('datatable1')); // Bind the form to the datatable for data synchronization
        var popupSendPopup = webix.ui({
            // Create a new Webix UI window for sending popups
            view: 'window',
            id: 'SendPopup',
            width: screen.width < 500 ? 350 : 650, // Adjust width based on screen size
            height: screen.width < 500 ? 850 : 650, // Adjust height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Enviar popup'),
                        align: 'center',
                    }, // Label for the popup window
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon for the toolbar
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup when the close icon is clicked
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'scrollview',
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form',
                    id: 'formSendPopup', // ID for the form
                    width: screen.width < 500 ? 350 : 650, // Adjust form width based on screen size
                    height: screen.width < 500 ? 850 : 600, // Adjust form height based on screen size
                    elements: [
                        {
                            view: 'text',
                            label: _('Título'), // Label for the title input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Position label based on screen size
                            name: 'Title', // Name of the input field
                            labelWidth: 150,
                            required: true, // Mark this field as required
                        },
                        {
                            view: 'textarea',
                            label: _('Contenido'), // Label for the content textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Content', // Name of the textarea
                            labelWidth: 150,
                            required: true, // Mark this field as required
                        },
                        {
                            view: 'checkbox',
                            label: _('¿Es un juego?'), // Label for the checkbox
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'IsGame', // Name of the checkbox
                            id: 'IsGame',
                            labelWidth: 200,
                        },
                        {
                            view: 'text',
                            label: _('URL Redirección'), // Label for the redirection URL input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Redirection', // Name of the input field
                            labelWidth: 150,
                            required: true, // Mark this field as required
                            id: 'RedirectionURL',
                        },
                        {
                            view: 'text',
                            label: _('URL Frame'), // Label for the frame URL input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Frame', // Name of the input field
                            labelWidth: 150,
                            required: false, // This field is optional
                            id: 'FrameURL',
                        },
                        {
                            view: 'combo',
                            label: _('Juego'), // Label for the game selection combo
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Product', // Name of the combo
                            id: 'ProductId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch game options based on user input
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API endpoint for fetching games
                                                    '{"Filter":"' + text + '"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse the response
                                                            if (!resp.HasError) {
                                                                // Check for errors in the response
                                                                vthis.parse(resp.Data); // Populate the combo with fetched data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            required: true, // Mark this field as required
                            labelWidth: 150,
                        },
                        {
                            view: 'textarea',
                            label: _('Usuarios Id'), // Label for the user IDs textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ClientId', // Name of the textarea
                            labelWidth: 150,
                            required: true, // Mark this field as required
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect', // Name of the country selection field
                            label: "<span class='icon-language'></span>" + _('País'), // Label with an icon
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150,
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Display flag icon and country name
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            required: true, // Mark this field as required
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Label for the send date picker
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateSend', // Name of the date picker
                            stringResult: true, // Return date as a string
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Mark this field as required
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the date picker
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Label for the expiration date picker
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateExpiration', // Name of the date picker
                            stringResult: true, // Return date as a string
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Mark this field as required
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the date picker
                        },
                        {
                            cols: [
                                // Define a row of buttons
                                {
                                    view: 'button',
                                    value: _('Cancelar'), // Label for the cancel button
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the popup on cancel
                                        $$('formSendPopup').setValues($$('formSendPopup').getCleanValues()); // Reset form values
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form',
                                    value: _('Enviar'), // Label for the send button
                                    click: function ($e) {
                                        var values = $$('formSendPopup').getValues(); // Get form values
                                        if ($$('formSendPopup').validate()) {
                                            // Validate form before sending
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendPopup', // API endpoint for sending the popup
                                                    '{"Title":"' +
                                                        values.Title +
                                                        '",  "Content":"' +
                                                        values.Content +
                                                        '", "IsGame":"' +
                                                        values.IsGame +
                                                        '", "Redirection":"' +
                                                        values.Redirection +
                                                        '", "Frame":"' +
                                                        values.Frame +
                                                        '", "Product":"' +
                                                        values.Product +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            data = JSON.parse(text); // Parse the response
                                                            if (data.HasError) {
                                                                // Check for errors in the response
                                                                webix.message({
                                                                    text: _('Error, comuniquese con soporte. '), // Show error message
                                                                    type: 'error',
                                                                });
                                                            } else {
                                                                webix.message(_('Popup enviado satisfactoriamente')); // Show success message
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendPopup').setValues($$('formSendPopup').getCleanValues()); // Reset form values after sending
                                            this.getTopParentView().hide(); // Hide the popup after sending
                                        } else {
                                            webix.message({
                                                // Show alert if validation fails
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _('Completa los campos...'), // Message prompting user to complete fields
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            onChange: function () {
                                this.validate(); // Validate fields on change
                            },
                        },
                    },
                },
            },
        });
        // Create a popup window for editing purposes
        var popupEditPopup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditPopup', // Unique identifier for the popup
            width: screen.width < 500 ? 350 : 650, // Set width based on screen size
            height: screen.width < 500 ? 950 : 750, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen on small screens
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    {
                        view: 'label',
                        label: _('Editar popup'),
                        align: 'center',
                    }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form inside the popup
                    id: 'formEditPopup', // Unique identifier for the form
                    width: screen.width < 500 ? 350 : 650, // Set form width based on screen size
                    height: screen.width < 500 ? 950 : 700, // Set form height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for Id
                            label: _('Id'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Id', // Name of the input
                            labelWidth: 150, // Width of the label
                            readonly: true, // Make the input read-only
                        },
                        {
                            view: 'text', // Text input for Title
                            label: _('Título'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Title', // Name of the input
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'textarea', // Textarea for Content
                            label: _('Contenido'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'checkbox', // Checkbox for IsGame
                            label: _('¿Es un juego?'), // Label for the checkbox
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 250, // Width of the label
                            name: 'IsGame', // Name of the checkbox
                            id: 'IsGameEdit', // Unique identifier for the checkbox
                        },
                        {
                            view: 'text', // Text input for Redirection URL
                            label: _('URL Redirección'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name of the input
                            labelWidth: 150, // Width of the label
                            required: true, // Mark as required
                            id: 'RedirectionURLEdit', // Unique identifier for the input
                        },
                        {
                            view: 'text', // Text input for Frame URL
                            label: _('URL Frame'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Frame', // Name of the input
                            labelWidth: 150, // Width of the label
                            id: 'FrameURLEdit', // Unique identifier for the input
                        },
                        {
                            view: 'combo', // Combo box for selecting a game
                            label: _('Juego'), // Label for the combo box
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Product', // Name of the combo box
                            id: 'ProductIdEdit', // Unique identifier for the combo box
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch data for the combo box
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax() // AJAX request to fetch data
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API endpoint
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message('Error! '); // Show error message
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Success handling
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                // Check for errors
                                                                vthis.parse(resp.Data); // Populate combo box with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'textarea', // Textarea for Client Id
                            label: _('Usuarios Id'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'richselect', // Rich select for Country
                            name: 'CountrySelectId', // Name of the rich select
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Width of the label
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Return formatted option
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Datepicker for DateSend
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name of the datepicker
                            stringResult: true, // Return string result
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'datepicker', // Datepicker for DateExpiration
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name of the datepicker
                            stringResult: true, // Return string result
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Click event for cancel button
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('formEditPopup').setValues($$('formEditPopup').getCleanValues()); // Reset form values
                                    },
                                },
                                {
                                    view: 'button', // Submit button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Button label
                                    click: function ($e) {
                                        // Click event for submit button
                                        var values = $$('formEditPopup').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to submit form
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SendPopup', // API endpoint
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Title":"' +
                                                    values.Title +
                                                    '",  "Content":"' +
                                                    values.Content +
                                                    '", "IsGame":"' +
                                                    values.IsGame +
                                                    '", "Redirection":"' +
                                                    values.Redirection +
                                                    '", "Frame":"' +
                                                    values.Frame +
                                                    '", "Product":"' +
                                                    values.Product +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelectId +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}', // Request body
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handling
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success handling
                                                        data = JSON.parse(text); // Parse response
                                                        if (data.HasError) {
                                                            // Check for errors
                                                            webix.message({
                                                                text: _('Error, comuniquese con soporte. '), // Show error message
                                                                type: 'error', // Error type
                                                            });
                                                        } else {
                                                            webix.message(_('Popup editado satisfactoriamente')); // Show success message
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditPopup').setValues($$('formEditPopup').getCleanValues()); // Reset form values
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditPopup').bind($$('datatable2')); // Bind the formEditPopup to datatable2 for interaction
        var popupSendFringe = webix.ui({
            // Create a new Webix UI window for sending a fringe
            view: 'window', // Define the view type as a window
            id: 'SendFringe', // Unique identifier for the window
            width: screen.width < 500 ? 350 : 650, // Set width based on screen size
            height: screen.width < 500 ? 850 : 650, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen for small screens
            head: {
                // Header configuration for the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns in the toolbar
                    {
                        view: 'label',
                        label: _('Enviar franja'),
                        align: 'center',
                    }, // Title label for the window
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body configuration of the window
                view: 'scrollview', // Enable vertical scrolling
                scroll: 'y', // Scroll direction
                body: {
                    // Inner body configuration
                    view: 'form', // Define the body as a form
                    id: 'formSendFringe', // Unique identifier for the form
                    width: screen.width < 500 ? 350 : 650, // Set form width based on screen size
                    height: screen.width < 500 ? 850 : 600, // Set form height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'textarea', // Textarea for content input
                            label: _('Contenido'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name attribute for the textarea
                            labelWidth: 150, // Width of the label
                            required: true, // Mark as required
                        },
                        {
                            view: 'textarea', // Textarea for user IDs input
                            label: _('Usuarios Id'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name attribute for the textarea
                            labelWidth: 150, // Width of the label
                            required: true, // Mark as required
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Label for the text input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name attribute for the text input
                            labelWidth: 150, // Width of the label
                            required: true, // Mark as required
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect', // Name attribute for the dropdown
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon for the dropdown
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Width of the label
                            options: {
                                // Options for the dropdown
                                body: {
                                    template: function (obj) {
                                        // Template for displaying options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Display flag icon and country name
                                    },
                                    data: countries, // Data source for the dropdown options
                                },
                            },
                            required: true, // Mark as required
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Label with icon for the datepicker
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name attribute for the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Mark as required
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the datepicker
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Label with icon for the datepicker
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name attribute for the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Mark as required
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the datepicker
                        },
                        {
                            cols: [
                                // Button configuration
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Click event for the button
                                        this.getTopParentView().hide(); // Hide the window
                                        $$('formSendFringe').setValues($$('formSendFringe').getCleanValues()); // Reset form values
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Button label
                                    click: function ($e) {
                                        // Click event for the button
                                        var values = $$('formSendFringe').getValues(); // Get form values
                                        if ($$('formSendFringe').validate()) {
                                            // Validate form
                                            webix // AJAX request to send data
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendFringe', // API endpoint
                                                    '{"Content":"' +
                                                        values.Content +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '" , "Redirection":"' +
                                                        values.Redirection +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}', // JSON payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error callback
                                                            webix.message('Error! '); // Display error message
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Success callback
                                                            data = JSON.parse(text); // Parse response
                                                            if (data.HasError) {
                                                                // Check for errors in response
                                                                webix.message({
                                                                    text: _('Error, comuniquese con soporte. '), // Display error message
                                                                    type: 'error',
                                                                });
                                                            } else {
                                                                webix.message(_('Franja enviada satisfactoriamente')); // Display success message
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendFringe').setValues($$('formSendFringe').getCleanValues()); // Reset form values
                                            this.getTopParentView().hide(); // Hide the window
                                        } else {
                                            webix.message({
                                                // Display validation error message
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _('Completa los campos...'), // Prompt to complete fields
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        // Configuration for form elements
                        on: {
                            onChange: function () {
                                // Event triggered on change
                                this.validate(); // Validate the form
                            },
                        },
                    },
                },
            },
        });
        // Create a popup window for editing a fringe
        var popupEditFringe = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditFringe', // Unique identifier for the window
            width: screen.width < 500 ? 350 : 650, // Set width based on screen size
            height: screen.width < 500 ? 850 : 650, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Enable fullscreen for small screens
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    {
                        view: 'label',
                        label: _('Editar franja'),
                        align: 'center',
                    }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the top parent view (the window)
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form inside the scrollview
                    id: 'formEditFringe', // Unique identifier for the form
                    width: screen.width < 500 ? 350 : 650, // Set form width based on screen size
                    height: screen.width < 500 ? 850 : 600, // Set form height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: _('Id'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Id', // Name of the input
                            labelWidth: 150, // Width of the label
                            readonly: true, // Make the input read-only
                        },
                        {
                            view: 'textarea', // Textarea for content
                            label: _('Contenido'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'textarea', // Textarea for user IDs
                            label: _('Usuarios Id'), // Label for the textarea
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name of the textarea
                            labelWidth: 150, // Width of the label
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Label for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name of the input
                            labelWidth: 150, // Width of the label
                            id: 'Redirection', // Unique identifier for the input
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect', // Name of the dropdown
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Width of the label
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Display flag icon and country name
                                    },
                                    data: countries, // Data source for the dropdown options
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name of the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the datepicker
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name of the datepicker
                            stringResult: true, // Return date as a string
                            labelWidth: 150, // Width of the label
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable time selection
                            value: createdLocalDate, // Default value for the datepicker
                        },
                        {
                            view: 'combo', // Combo box for state selection
                            label: _('Estado'), // Label for the combo box
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'State', // Name of the combo box
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') }, // Activated state
                                { id: 'I', value: _('Inactivado') }, // Inactivated state
                            ],
                            labelWidth: 150, // Width of the label
                        },
                        {
                            cols: [
                                // Container for buttons
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Click event for cancel button
                                        this.getTopParentView().hide(); // Hide the window
                                        $$('formEditFringe').setValues($$('formEditFringe').getCleanValues()); // Reset form values
                                    },
                                },
                                {
                                    view: 'button', // Submit button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Button label
                                    click: function ($e) {
                                        // Click event for submit button
                                        var values = $$('formEditFringe').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to send data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type to JSON
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SendFringe', // API endpoint
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Content":"' +
                                                    values.Content +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '" , "Redirection":"' +
                                                    values.Redirection +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelect +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}', // JSON string of form values
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error callback
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success callback
                                                        data = JSON.parse(text); // Parse response text
                                                        if (data.HasError) {
                                                            // Check for errors in response
                                                            webix.message({
                                                                text: _('Error, comuniquese con soporte. '), // Show error message
                                                                type: 'error', // Set message type to error
                                                            });
                                                        } else {
                                                            webix.message(_('Franja editada satisfactoriamente')); // Show success message
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditFringe').setValues($$('formEditFringe').getCleanValues()); // Reset form values
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditFringe').bind($$('datatable3')); // Binds the formEditFringe to datatable3
        this.on(this.app, 'addMessage:button', (filter) => {
            // Event listener for 'addMessage:button' event
            popupAdd.show(); // Shows the popup for adding a message
        });
        this.on(this.app, 'messages:filter', (filterData) => {
            // Event listener for 'messages:filter' event
            var object = Object.entries(filterData); // Converts filterData object to an array of entries
            var string1 = ''; // Initializes a string to build query parameters
            var typeReport = ''; // Initializes a variable to hold the type of report
            for (var i = 0; i < object.length; i++) {
                // Iterates through each entry in the object
                if (object[i][0] == 'TypeReport') {
                    // Checks if the key is 'TypeReport'
                    if (object[i][1] == '0') {
                        // Checks for report type 0
                        typeReport = '0'; // Sets typeReport to '0'
                    } else {
                        if (object[i][1] == '1') {
                            // Checks for report type 1
                            typeReport = '1'; // Sets typeReport to '1'
                        } else {
                            if (object[i][1] == '2') {
                                // Checks for report type 2
                                typeReport = '2'; // Sets typeReport to '2'
                            } else {
                                if (object[i][1] == '3') {
                                    // Checks for report type 3
                                    typeReport = '3'; // Sets typeReport to '3'
                                }
                            }
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Checks if the value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Checks if the key is 'Datepicker'
                        var date = object[i][1].split(' - '); // Splits the date range into start and end dates
                        console.log(date); // Logs the date array to the console
                        string1 = string1 + '&dateFrom=' + date[0]; // Appends start date to the query string
                        string1 = string1 + '&dateTo=' + date[1]; // Appends end date to the query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Appends other parameters to the query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Checks if the value is an object
                        var object2 = Object.entries(object[i][1]); // Converts the nested object to an array of entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterates through each entry in the nested object
                            if (object2[j][1] !== null) {
                                // Checks if the value is not null
                                if (object2[j][0] === 'start') {
                                    // Checks for 'start' key
                                    var d = new Date(object2[j][1]); // Creates a Date object from the start value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() + // Gets the year
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + // Gets the month, formatted to two digits
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) + // Gets the day, formatted to two digits
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) + // Gets the hour, formatted to two digits
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) + // Gets the minutes, formatted to two digits
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Gets the seconds, formatted to two digits
                                    string1 = string1 + '&' + dateFrom; // Appends the formatted start date to the query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Checks for 'end' key
                                        var d = new Date(object2[j][1]); // Creates a Date object from the end value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() + // Gets the year
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + // Gets the month, formatted to two digits
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) + // Gets the day, formatted to two digits
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) + // Gets the hour, formatted to two digits
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) + // Gets the minutes, formatted to two digits
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Gets the seconds, formatted to two digits
                                        string1 = string1 + '&' + dateTo; // Appends the formatted end date to the query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (typeReport == '0' || typeReport == '') {
                // Checks if the report type is 0 or not set
                grid.show(); // Shows the main grid
                $$('toolbar').show(); // Shows the main toolbar
                $$('datatable1').hide(); // Hides datatable1
                $$('datatable2').hide(); // Hides datatable2
                $$('datatable3').hide(); // Hides datatable3
                $$('toolbar1').hide(); // Hides toolbar1
                $$('toolbar2').hide(); // Hides toolbar2
                $$('toolbar3').hide(); // Hides toolbar3
                grid.clearAll(); // Clears all data from the grid
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loads data into the grid with the constructed query string
            } else {
                if (typeReport == '1') {
                    // Checks if the report type is 1
                    $$('datatable1').show(); // Shows datatable1
                    $$('toolbar1').show(); // Shows toolbar1
                    grid.hide(); // Hides the main grid
                    $$('datatable2').hide(); // Hides datatable2
                    $$('datatable3').hide(); // Hides datatable3
                    $$('toolbar').hide(); // Hides the main toolbar
                    $$('toolbar2').hide(); // Hides toolbar2
                    $$('toolbar3').hide(); // Hides toolbar3
                    grid.clearAll(); // Clears all data from the grid
                    $$('datatable1').clearAll(); // Clears all data from datatable1
                    $$('datatable2').clearAll(); // Clears all data from datatable2
                    $$('datatable3').clearAll(); // Clears all data from datatable3
                    $$('datatable1').load(url1 + '?start=0&count=' + $$('datatable1').data.$pagesize + string1); // Loads data into datatable1 with the constructed query string
                } else {
                    if (typeReport == '2') {
                        // Checks if the report type is 2
                        $$('datatable2').show(); // Shows datatable2
                        $$('toolbar2').show(); // Shows toolbar2
                        grid.hide(); // Hides the main grid
                        $$('datatable1').hide(); // Hides datatable1
                        $$('datatable3').hide(); // Hides datatable3
                        $$('toolbar1').hide(); // Hides toolbar1
                        $$('toolbar').hide(); // Hides the main toolbar
                        $$('toolbar3').hide(); // Hides toolbar3
                        grid.clearAll(); // Clears all data from the grid
                        $$('datatable1').clearAll(); // Clears all data from datatable1
                        $$('datatable2').clearAll(); // Clears all data from datatable2
                        $$('datatable3').clearAll(); // Clears all data from datatable3
                        $$('datatable2').load(url2 + '?start=0&count=' + $$('datatable2').data.$pagesize + string1); // Loads data into datatable2 with the constructed query string
                    } else {
                        if (typeReport == '3') {
                            // Checks if the report type is 3
                            $$('datatable3').show(); // Shows datatable3
                            $$('toolbar3').show(); // Shows toolbar3
                            grid.hide(); // Hides the main grid
                            $$('datatable1').hide(); // Hides datatable1
                            $$('datatable2').hide(); // Hides datatable2
                            $$('toolbar1').hide(); // Hides toolbar1
                            $$('toolbar2').hide(); // Hides toolbar2
                            $$('toolbar').hide(); // Hides the main toolbar
                            grid.clearAll(); // Clears all data from the grid
                            $$('datatable1').clearAll(); // Clears all data from datatable1
                            $$('datatable2').clearAll(); // Clears all data from datatable2
                            $$('datatable3').clearAll(); // Clears all data from datatable3
                            $$('datatable3').load(url3 + '?start=0&count=' + $$('datatable3').data.$pagesize + string1); // Loads data into datatable3 with the constructed query string
                        }
                    }
                }
            }
            filter = string1; // Assigns the constructed query string to filter
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load grid data with sorting parameters and current filter
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Retrieve the clicked item from the grid
            var item = this.getItem(id);
            // Trigger a custom event with the item's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Attach an event handler for the 'onItemDblClick' event of the grid
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Retrieve the double-clicked item from the grid
            var item = this.getItem(id);
            // Show a popup for the item
            popup.show();
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load grid data filtered by the selected player ID
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        });

        // Bind the edit form to the data table
        $$('editform').bind($$('datatable'));

        // Listen for the 'sendInvasiveBanner:button' event from the app
        this.on(this.app, 'sendInvasiveBanner:button', (filterData) => {
            // Show the invasive banner popup
            popupSendInvasiveBanner.show();
            // Clear validation errors in the invasive banner form
            $$('formSendInvasiveBanner').clearValidation();
        });

        // Listen for the 'sendPopup:button' event from the app
        this.on(this.app, 'sendPopup:button', (filterData) => {
            // Show the popup for sending
            popupSendPopup.show();
            // Clear validation errors in the send popup form
            $$('formSendPopup').clearValidation();
        });

        // Listen for the 'sendfringe:button' event from the app
        this.on(this.app, 'sendfringe:button', (filterData) => {
            // Show the fringe sending popup
            popupSendFringe.show();
            // Clear validation errors in the send fringe form
            $$('formSendFringe').clearValidation();
        });
        // Hide the ProductId element initially
        $$('ProductId').hide();

        // Attach an event listener for changes on the IsGame element
        $$('IsGame').attachEvent('onChange', function (newv, oldv) {
            // Check if the value of IsGame is '1'
            if ($$('IsGame').getValue() == '1') {
                // Hide FrameURL and RedirectionURL elements if IsGame is true
                $$('FrameURL').hide();
                $$('RedirectionURL').hide();
                // Show ProductId element
                $$('ProductId').show();
            } else {
                // Show FrameURL and RedirectionURL elements if IsGame is false
                $$('FrameURL').show();
                $$('RedirectionURL').show();
                // Hide ProductId element
                $$('ProductId').hide();
            }
        });

        // Attach an event listener for changes on the IsGameEdit element
        $$('IsGameEdit').attachEvent('onChange', function (newv, oldv) {
            // Check if the value of IsGameEdit is '1'
            if ($$('IsGameEdit').getValue() == '1') {
                // Hide FrameURLEdit and RedirectionURLEdit elements if IsGameEdit is true
                $$('FrameURLEdit').hide();
                $$('RedirectionURLEdit').hide();
                // Show ProductIdEdit element
                $$('ProductIdEdit').show();
            } else {
                // Show FrameURLEdit and RedirectionURLEdit elements if IsGameEdit is false
                $$('FrameURLEdit').show();
                $$('RedirectionURLEdit').show();
                // Hide ProductIdEdit element
                $$('ProductIdEdit').hide();
            }
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
